import React from "react";
import { Svg } from "../componet/Form/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="18"
      fill="none"
      viewBox="0 0 14 15"
      house="true"
    >
      <path
        stroke="#CE6C80"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.28"
        d="M1.596 5.76l5.758-4.478 5.758 4.478v7.037a1.28 1.28 0 01-1.28 1.28H2.876a1.28 1.28 0 01-1.28-1.28V5.76z"
      ></path>
      <path
        stroke="#CE6C80"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.28"
        d="M5.435 14.077V7.679h3.838v6.398"
      ></path>
    </Svg>
  );
}

export default Icon;
